module.exports = {

  // 发现页
  find: {
    str1: "资讯",
    str2: "查看更多 >",
    str3: "经常做运动有必要监测一下血氧吗？",
    str4: "你的血氧含量正常吗？",
    str5: ["健康", "运动"],
    str6: "人浏览",
    str7: "控制静息心率对于冠心病的重要性。",
    str8: "这点你知道吗？",
    str9: "关于运动心率区间。",
    str10: "你真的了解运动心率区间吗？",
    str11: "比癌症更可怕的是高血压。",
    str12: "高血压怎样伤害身体？",
    str13: "血糖偏高怎么办？",
    str14: "血糖在什么范围内才算正常？",
    str15: "只有胖人才会得高血脂吗？",
    str16: "高血脂的5个误区。",

    str17: "“血氧含量是指血液中的含氧总量，包括血液中物理溶解的氧和与血红蛋白结合的氧。”人体吸入肺部的氧气，最终会与红细胞中的血红蛋白结合，然后被分配到身体的各个器官、组织中，只有这样细胞才能生存下来，正常工作。",
    str18: "但是，并非每个血红蛋白都会被选中，没有发生结合的血红蛋白就落单了。和氧气组成CP的血红蛋白÷（CP数+落单血红蛋白数）的值就是血氧饱和度，简单来说，它用来衡量携带氧气的红细胞比例。",
    str19: "那么血氧饱和度多少是正常呢？",
    str20: "大多数时候，每个血红蛋白都能找到自己的氧气伴侣，健康人的血氧饱和度保持在95-100%之间是正常的。",
    str21: "明白了血氧含量的概念之后，下一个问题是，血氧含量的高低对人体有哪些影响？",
    str22: "因为人体内所有细胞都依赖氧气为生，血氧含量几乎会影响到身体的每一个部分。血氧饱和度低会出现全身的严重并发症，例如神经系统缺氧会导致头痛头晕、暴躁易怒、神智障碍以至于昏迷；心血管系统缺氧会导致心肌缺血，严重的会出现心脏骤停，心力衰竭；呼吸系统缺氧会导致呼吸衰竭，呼吸停止等。",
    str23: "在国内运动型猝死的研究报道中，有部分病例表明运动者心脏没有发生器质性病变和异常，死因可能是运动负荷超出其承受范围，心脏循环系统需要的血液量和需氧量突增，而供给量却相对减少。在这种血氧供不应求的状态下，运动者的心肌会出现急性缺血、心脏停搏和脑血中断，进而发生运动性心脏猝死和脑性猝死。",
    str24: "普通人要使血氧含量保持在正常水平，一是保持空气新鲜、流通，二是加强心肺功能锻炼，增强呼吸能力和血液运输能力。规律的运动，尤其是有氧运动，能有效提升呼吸系统的功能，在一定程度上提高抵抗疾病的能力。因此，提倡大家保持规律运动，尤其是有氧运动。",
    str25: "而对于平时运动较少，突然运动量增加，或者运动缺乏专业指导的普通人，有条件可以做一下血氧检测。",
    str26: "出于生活便利的需求，目前已有“血氧手表”等可穿戴家用检测设备，帮助人们足不出户检测血氧饱和度。",

    str27: "董女士冠心病已经3年了，最近又因为疾病复发来医院了，医生给她做了一些基础检查，血压、血脂、血糖控制的都挺好，可一看心率88次/分钟，有些不对劲，就问董女士，给她开的倍他乐克有没有按时吃，董女士的回答让医生找到了她复发的原因。",
    str28: "董女士在1年前就已经停用了倍他乐克，因为她看了药物说明书看见了“降血压”几个字，就判断倍他乐克是降压药，她同时还在吃着“沙坦”这种降压药，就想着两种降压药减一种，如果血压也能控制好，不是就能少吃药还治病吗！就是用这样的小聪明，停服了倍他乐克1年多，血压是没什么问题，但是冠心病却复发了。",
    str29: "董女士疾病的复发表面上看来是自己自行停药，而造成的问题，其实本质上是很多患者都不了解的“控制静息心率对于冠心病的重要性”。",
    str30: "什么是静息心率？",
    str31: "静息心率是指在清醒、不活动的安静状态下每分钟心跳的次数，是生理检查的一项重要指标，常作为评估心血管系统健康的标准之一。",
    str32: "静息心率对冠心病患者来说意味着什么？",
    str33: "临床已经证实静息心率增快是冠心病发病与死亡的一项独立危险因子。静息心率与冠心病发病危险因素例如高血压、高纤维蛋白原血症、高甘油三酯血症和高血糖聚集性均有关联，总的来说，静息心率过快易发冠心病。所以，控制好静息心率是可以降低冠心病发病率的。",
    str34: "有什么控制静息心率的好方法吗？",
    str35: "比较直接的方式是药物控制心率。临床普遍认为，非二氨吡嘧类钙拮抗剂（异博定、地尔硫卓）、β阻滞剂（氨酰心安、美多心安、倍他乐克）和地高辛可以有效地控制静息心率，应用方面因为要考虑患者的耐受性，常常需要根据情况改换以及联合用药。",
    str36: "有心血管疾病病史的朋友还要注意在日常生活中保持良好的心理状态。别激动，别发火，减少情绪的大起大落。",
    str37: "忌烟忌酒。抽烟和饮酒都会使交感神经兴奋，从而加快心率。",
    str38: "冠心病患者清晨5分钟自测静息心率",
    str39: "要测得相对准确的静息心率其实很简单，只需利用每天起床的5分钟就能完成：",
    str40: "1、起床后静坐3-4分钟，让身体和精神都保持在平静状态。",
    str41: "2、可以利用带心率监测功能的手表、手环、心电监测仪，或直接用手号脉，选择腕部或颈部脉波搏动部位，监测1分钟，可以得到自己的静息心率。",
    str42: "3、睡眠不足、饮酒、咖啡、浓茶等会对心率产生影响，需要监测静息心率的人群时尽量避免上述因素。",
    str43: "对于有心血管病的患者，建议将清晨刚醒未起时心率控制在50~60次/分（或 55~60次/分）比较合适，如果日常休息态，建议心率控制在70次/分以下，对于活动状态下，建议心率增加小于20次/分为佳，同时结合自身的实际，以不出现自身不适为准，有条件者可在医生指导下行相关活动。对于房颤病人建议心率控制在110次/分以下。",
    str44: "有心血管疾病的患者们，如果您之前没有足够重视自己的心率，那么从看完这篇文章开始，每天花费5分钟，测测自己的心率，高了低了一目了然，心率跟血压、血脂、血糖一样重要。",

    str45: "静息心率（Rest Heart Rate，简写RHR）和 最大心率（Max Heart Rate，简写MHR）是决定个人训练区间最重要的两个参数。静息心率是指安静状态下的心跳频率。安静状态下，成人正常心率为60～100次/分钟，理想心率应为55～70次/分钟（运动员的心率较普通成人偏慢，一般为50次/分钟左右）。 最大心率值最常用计算方法是用220减去你的年龄从而得到你的最大心跳频率，例如：一个32岁的人的最大心跳频率为188跳每分钟，即MHR=220-年龄。正确了解跑步时的平均心率对于人体健康水平的影响，都将有助于你获得更加理想高效的锻炼结果。",
    str46: "最常使用的是从50%到100%最大心率划分成5个区间，由低到高运动强度逐渐增大，训练效果也随之变化。",
    str47: "灰色区间1：热身恢复锻炼，50-60%MHR。",
    str48: "轻度运动，耗能极少，用于跑步前的动态热身，跑步后的放松活动，也是人体感觉最舒适的心率区间，可以轻松通过散步或慢走达到。在此区间的活动对于降低血压，提升心血管健康以及减脂方面会有一定的帮助，但是效率很低。",
    str49: "蓝色区间2：燃脂耐力锻炼，60%-70%MHR。",
    str50: "身体以脂肪代谢为主。适合以放松恢复为目的 慢跑和椭圆机、健身操等轻松锻炼项目，也可通过快走/慢跑/热身运动进入此区间，在此区间保持一段时间可以让身体准备好增强脂肪代谢，接受高强度运动。",
    str51: "绿色区间3：有氧心肺锻炼，70%-80%MHR。",
    str52: "中到高度有氧区间，糖原代谢比例增大，有效锻炼有氧能力，提高脂肪利用率。强度适中，适合 健身减肥为目的跑步者， 马拉松选手的大部分训练应该在这一区间，处于一般人正常运动强度，可通过持续慢跑进入此区间。此区间内的运动，对于心血管和呼吸系统的健康程度提升明显，此外，卡路里消耗和燃脂水平也较为均衡，每60分钟的训练，达成20-30分钟在此区域则比较理想。",
    str53: "橙色区间4：肌力强化锻炼，80%-90%MHR。",
    str54: "乳酸阈值区间，糖原代谢为主，出现乳酸堆积。强度较大。节奏跑（tempo）和马拉松配速跑在这一区间。可以通过高强度运动进入此区间，此时身体会感觉较为不适，但这一区域对于HIIT/EPOC训练法来说是最重要的：训练中，新陈代谢水平高，脂肪代谢非常明显；训练后，由于机体需要代谢EPOC产生的乳酸，也会保持长时间的热量消耗。 每60分钟的训练，达成10-20分钟在此区域则比较理想。用于训练身体提高乳酸耐受性， 每周训练不应超过1.5小时。",
    str55: "红色区间5 : （力竭等级）无氧极限锻炼90%-100%MHR。",
    str56: "接近无氧代谢，几乎全部能量来源于糖原分解。心脏负担很大，锻炼绝对速度能力， 适合有经验的跑步者，从运动效果方面来讲，此区间的代谢水平最高，但是运动过程中进入此区间并不是必要的，而且是不推荐的。如果进入了此区间，请逐渐降低运动强度，并将每次的持续时间控制在3mi-5min以内，从而控制运动风险。",

    str57: "人人谈癌色变，但其实杀死中国人的头号杀手，不是癌症而是心血管病。而心血管病死亡里头号致死因素是常见的高血压。",
    str58: "高血压是指以体循环动脉血压（收缩压和/或舒张压）增高为主要特征，可伴有心、脑、肾等器官的功能或器质性损害的临床综合征。流行病学调查显示，我国已有2.7亿人群患有高血压，成为了威胁中国居民健康的主要慢性病之一。致死率高但人群知晓率低，高血压可谓是名副其实的“隐形杀手”了，更可怕的是它会引发各种致命的高血压并发症。",
    str59: "高血压怎样伤害身体?",
    str60: "在“三高”、吸烟、肥胖等因素的共同作用下，不可逆转的损伤持续积累，加重影响全身血液供应，逐渐造成器官组织结构改变甚至危及生命。",
    str61: "心脏",
    str62: "心脏是推动全身血液循环的“血泵”。一方面血压升高，血管变细，阻力变大，给心脏带来了额外的工作负担。心脏为了工作需要变得肥大，出现左心室肥厚；但随着高血压进展，心脏最终仍然不堪重负，出现心力衰竭，导致死亡。另一方面，高血压促进冠状动脉粥样硬化，冠状动脉变窄或阻塞，造成心肌缺血、缺氧或坏死，就是俗称的冠心病；心肌缺血也可引发心律失常。心律失常和急性心肌梗死发作可直接导致猝死，也会引起和加速心力衰竭，最终死亡。临床数据显示，收缩压每升高10mmHg，缺血性心脏病风险升高31%。",
    str63: "脑",
    str64: "高血压同样会损伤脑血管。如果脑血管突然破裂出血，或者脑血管阻塞导致血液不能流入，会使脑组织产生损伤，导致脑梗死，就是俗称的“中风”。脑梗死引发的脑组织损伤可能是暂时的，也可能是永久的。根据脑组织损伤发生的部位不同，患者的结局也不同：直接死亡、肢体偏瘫、失明、失语、失忆、读写困难、吞咽困难、行走障碍等，受脑部支配的一切功能都有可能发生障碍，或者彻底丧失。",
    str65: "高血压患者发生脑梗死的危险性是正常人的4到6倍。80%的脑梗死与高血压有关，其致死率是50%~60%，致残率是75%。",
    str66: "肾",
    str67: "肾脏是血液系统的过滤器，通过调节排出身体的水量和物质，可以起到调节血压、代谢有害物质的作用。肾脏内部密集的小血管网很容易被高血压损伤，一旦肾功能下降，肾脏调节血压的功能受损，就会进一步使血压升高，进入恶性循环，最终发展为肾功能衰竭也就是尿毒症，有害物质和多余的液体在人体堆积，不得不靠持续透析延续生命，直至死亡。",
    str68: "生殖系统",
    str69: "高血压引起血管狭窄或堵塞，性器官供血不足，会导致性功能障碍。在男性中，主要表现为勃起功能障碍；在女性中，主要表现为性欲减退、阴道干涩、无法高潮，影响患者性生活的满意度。妊娠高血压严重影响母婴健康，是孕产妇和围生儿发病和死亡的主要原因之一。怀孕期间，因为母亲要负担自身和胎儿两者的血液供应，因此孕期高血压会对母亲和胎儿都产生不良影响。对于胎儿，妊娠高血压可导致胎盘血流不足，胎儿吸收不到足够的营养和氧气，因而出现早产、胎儿宫内窘迫及死亡、胎儿宫内生长迟缓、死产、新生儿窒息死亡等情况。对于母亲，可引起胎盘早期剥离、心力衰竭、凝血功能障碍、脑出血、肾功能衰竭及产后血液循环障碍等致命情况。孕妇高血压病情越重，对胎儿的不良影响越大。此外，高血压还可引起钙质流失，导致骨质疏松、骨折；或引起周围血管病，导致抽筋、跛行、消化不良等。",
    str70: "监测血压",
    str71: "因为高血压风险高损害大，所以越早确诊越早治疗越好；但高血压早期往往没有明显症状，因此能尽早确诊高血压的唯一手段，就是到正规医疗机构，由专业人士进行标准的血压测量。",
    str72: "对于已经确诊的高血压患者，坚持规律自测血压也同样重要，不能仅凭主观症状和感受来判断病情。",
    str73: "高血压病人的血管弹性差，同样的血压变化，高血压患者的血管比正常人更容易堵塞或破裂，引起急性致命的不良心血管事件（比如脑梗死、心肌梗死等）。",
    str74: "稳定的血压数值，对于延长高血压患者的寿命至关重要。",
    str75: "改善生活方式",
    str76: "随着年纪的增长血压升高是正常现象但实际上高血压的成因十分复杂和遗传、饮食、不健康的生活习惯等都有关系那么应该如何正确应对高血压呢？最主要的还是早期预防和治疗。高血压患者应在饮食和生活习惯上注意以下几点：",
    str77: "1、合理饮食，尤其注意低钠",
    str78: "应遵循低盐、低脂、低热量原则，并注意饮食结构合理搭配，多吃蔬菜水果。少吃腌制的肉类、蔬菜。少用高钠的调料，比如酱油、蚝油、沙拉酱、番茄酱、汤料包；多用天然调味料，如葱、姜、蒜、胡椒、柠檬等。",
    str79: "2、戒烟",
    str80: "香烟中的尼古丁会让中枢神经和交感神经兴奋，使心率加快，促使肾上腺释放大量儿茶酚胺，使心跳更快，收缩压和舒张压都会升高。",
    str81: "3、限酒或戒酒",
    str82: "大量数据表明，饮酒量与血压水平呈正性线性相关。尤其是中年人，更应该适量饮酒，最好是戒酒，因为饮酒对身体毫无益处。",
    str83: "4、坚持运动",
    str84: "早在1988年，美国高血压联合会议正式确立了运动疗法为高血压综合治疗的方法之一。每周至少五天，进行30分钟左右的有氧运动，如步行、慢跑、打太极拳等，运动以中低强度为宜。但是，重度高血压患者或者有心衰等并发症的人群，最好先控制病情，不要着急运动。",
    str85: "5、减体重",
    str86: "肥胖是高血压的危险因素之一，研究发现超过正常体重25公斤的肥胖者，其收缩压可高于正常人1.33千帕（10mmHg），舒张压高0.93千帕（7mmHg）。体重每减5公斤血压可下降10~20mmHg",
    str87: "6、缓解压力、情绪稳定",
    str88: "工作、生活中压力比较大、精神比较紧张的情况下，身体会分泌儿茶酚胺，引起血管收缩，造成排血时阻力加大，易引起血压升高。所以要学会自我缓解压力。高血压病人应该避免情绪激动及过度紧张、焦虑，避免发脾气，维持情绪稳定，保持良好心情。",
    str89: "以上说的都是日常生活中的注意事项都是最基本的要求能做到的话对控制血压有莫大的好处",
    str90: "控制血压最重要的还是",
    str91: "7、坚持用药",
    str92: "只有合理用药，才能有效减少心脑血管意外，防止高血压、肾病等并发症的发生。此外，服药期间切勿自行断药、换药或减药，应定期复查，根据医生建议调整用药。",
    str93: "还要记住，每天都应该监测血压。",

    str94: "糖尿病也是威胁人们生命健康的一大疾病之一，目前我国患上糖尿病的人数已经高达1亿多，中年以后越来越多的人都被糖尿病缠上。",
    str95: "得了糖尿病之后，就需要长期服用药物或者注射胰岛素来稳定血糖，还有一些老人，虽然没有得糖尿病，但是也比较关注自己的血糖变化，就害怕自己也被糖尿病盯上，因此也会定期去医院或药店测血糖。",
    str96: "那么对于正常人来说，血糖在什么范围内才算正常？国家规定的血糖标准当中显示正常的血糖值是要保持在空腹状态之下健康人群的血糖值普遍在4.4~7.0mmol/L左右。",
    str97: "当然即便是出现了血糖偏高的情况也不要担心，首先要做的是积极寻求医生的帮助，并且积极配合医生的治疗，将血糖控制在合理范围之内，如果前期就出现了血糖偏高的情况，进行积极控制的话，也有可能会发生逆转。",
    str98: "血糖偏高的人，除了依靠药物，生活调理也很关键，医生提出了以下几点：",
    str99: "1、饮食干预",
    str100: "首先要改掉自己的饮食习惯，做好饮食结构调整，饮食干预对于血糖稳定是很关键的，除了少吃高糖食物以外，对于高碳水高脂肪高热量食物也要少吃，这种食物会降低自身代谢，不利于血糖稳定。",
    str101: "2、运动干预",
    str102: "血糖偏高之后的，平时也要加强运动量，多运动能够提高新陈代谢，加速血液循环，提高胰岛素的敏感性，更有利于稳定血糖。",
    str103: "3、多喝水",
    str104: "多喝水能够稀释血液浓度，而且还能提高新陈代谢，加速血液循环，更有利于血糖的稳定。",
    str105: "怎么才能使血糖更准确？",
    str106: "因为影响血糖的因素有很多，为了保证数值更加准确，建议大家测量血糖时一定要空腹测量，而且也要保证平和的心态，不要太过紧张。",

    str107: "有调查结果显示，中国成人血脂异常高达40.4%，也就是说平均每10个成年人就有4个高血脂。大家都知道血脂太高了不好，体检时发现血脂高、胆固醇高，就开始慌了。",
    str108: "为什么瘦的人也会高血脂？如何了解自己的血脂水平？是不是不能吃油、不能吃鸡蛋？",
    str109: "高血脂——危险的血管炸弹",
    str110: "我们说的高血脂，指的是血脂异常。也就是下面4个血脂检查指标中，出现任意一项都是高血脂——",
    str111: "TC总胆固醇→高了",
    str112: "TG甘油三酯→高了",
    str113: "LDL-C低密度脂蛋白胆固醇（坏胆固醇）→高了",
    str114: "HDL-C高密度脂蛋白胆固醇（好胆固醇）→低了",
    str115: "通常来说，「高血脂」本身不会造成明显症状。但如果血管中粘附的脂质越多、管腔越狭窄，就会容易导致冠状动脉粥样硬化斑块的形成，出现冠心病、心梗、脑梗等，严重会危及生命的。",
    str116: "高血脂的5个误区",
    str117: "1、只有胖人才会得高血脂？",
    str118: "通常，高血脂多发生于肥胖及中老年群体，但并不是胖人的专属。血脂是否会偏高，并不单纯是因为摄入脂肪过多引起的。生活方式、遗传因素、疾病、药物均可能导致高血脂。所以会看到，很多体型苗条的人也会得高血脂。",
    str119: "2、高血脂不能吃鸡蛋？",
    str120: "蛋黄的胆固醇含量较高，高血脂患者会担心吃鸡蛋加重病情。但其实只要不吃太多，每天吃一个，完全没问题。血脂中的胆固醇大部分来源于内源性生成，即使食物中含有较多胆固醇，对于胆固醇的平衡影响也不大。",
    str121: "3、喝醋可以降血脂？",
    str122: "这种说法并没有什么科学依据，醋不可能直接到达血管里，更谈不上软化血管、降血脂。大量喝醋，由于醋酸的刺激性，还会损伤胃粘膜，到时候后悔都来不及了。",
    str123: "4、血脂水平正常了，就不用吃药了吗？",
    str124: "如果只靠药物来改善血脂水平，立即停药有一定风险。最好在用药的同时结合生活方式的调节。血脂水平稳定后，在医生的指导下，进行下一步操作，但绝不能自己随意减药或者停药。",
    str125: "5、血脂高就不能吃肉、吃油？",
    str126: "肉类和油类都含有身体必需的营养物质。吃素食，虽然可能会改善血脂异常，但长期下去，容易出现营养不良。",
    str127: "控血脂，做到这3点",
    str128: "血脂和生活方式关系密切，好的生活方式是改善高血脂的基础。",
    str129: "1、定期查血脂",
    str130: "20～40岁，至少 5 年测量 1 次；",
    str131: "40 岁以上男性和绝经期后女性，每年检测 1 次；",
    str132: "高血压、糖尿病、肥胖、吸烟的人，每 3～6 个月检查 1 次；",
    str133: "2、控制饮食，少吃饱和脂肪",
    str134: "饱和脂肪就是我们所说的「坏脂肪」，如果摄入过多会增加体内胆固醇含量。少吃饱和脂肪，可以这样做：",
    str135: "植物油（椰子油、棕榈油除外）代替动物油；",
    str136: "少吃猪肉、牛肉等红肉，多吃鸡肉、鱼肉等白肉，吃肉时把皮去掉；",
    str137: "少吃油炸食品、糕点；",
    str138: "脱脂牛奶代替全脂牛奶；",
    str139: "3、多运动",
    str140: "坚持每周 5 天，每天 30 分钟的中等强度运动，有助于控制血脂。 可以根据自身爱好，选择适合自己的运动，比如：慢跑、快步走、游泳、广场舞、打太极都可以。如果血脂高到了要吃药的地步，一定要按时吃药，定期检查。",

    activity1: "活动",
    activity2: "全部",
    activity3: "创建",
    activity4: "我的",
    activity5: "进行中",
    activity6: "暂无进行中活动",
    activity7: "已结束",
    activity8: "暂无已结束活动",
    activity9: "请添加活动海报",
    activity10: "请输入活动名称",
    activity11: "类型",
    activity12: "请选择活动类型",
    activity13: ["骑行", "跑步", "徒步"],
    activity14: "取消",
    activity15: "确定",
    activity16: "开始时间",
    activity17: "请选择开始时间",
    activity18: "结束时间",
    activity19: "请选择结束时间",
    activity20: "报名截止时间",
    activity21: "请选择截止时间",
    activity22: "活动地点",
    activity23: "请填写活动地址",
    activity24: "下一步",
    activity25: "开始时间/结束时间/报名时间关系错误",
    activity26: "姓名",
    activity27: "请输入真实姓名",
    activity28: "手机号码",
    activity29: "请输入手机号码",
    activity30: "人数限定",
    activity31: "不限定",
    activity32: "自定义输入",
    activity33: "活动描述",
    activity34: "请输入活动描述",
    activity35: "上一步",
    activity36: "完成",
    activity37: "创建中...",
    activity38: "我参与的活动",
    activity39: "暂无参加的活动",
    activity40: "我创建的活动",
    activity41: "暂无创建的活动",
    activity42: "请上传图片格式",
    activity43: "上传中...",
    activity44: "人报名",
    activity45: "跑步活动",
    activity46: "骑行活动",
    activity47: "徒步活动",
    activity48: "年",
    activity49: "月",
    activity50: "日",
    activity51: "时",
    activity52: "分",

    foot1: "好物推荐",
    foot2: "1963YH智能手表",
    foot3: "运动、体温、心率、血氧",
    foot4: "J-style红外线额温计",
    foot5: "非接触式、一秒测温"
  },
  // 一体机
  machine: {
    index1: "友宏一体机",
    index2: "解除绑定",
    index3: "分享",
    index4: "重新绑定",
    index5: "已绑定",
    index6: "最近测量 ",
    index7: [" 上午", " 下午"],
    index8: "参考范围 >",
    index9: "血压心率",
    index10: "血压",
    index11: "心率",
    index12: "血脂四项",
    index13: "总胆固醇",
    index14: "甘油三酯",
    index15: "低密度脂蛋白胆固醇",
    index16: "高密度脂蛋白胆固醇",
    index17: "血糖",
    index18: "餐前血糖",
    index19: "餐后血糖",
    index20: "尿酸",
    index21: "测量记录",
    index22: "设置",

    range1: "血压参考范围",
    range2: ["高压", "低压"],
    range3: "静态心率参考范围",
    range4: "总胆固醇参考范围",
    range5: "甘油三酯参考范围",
    range6: "低密度脂蛋白胆固醇参考范围",
    range7: "高密度脂蛋白胆固醇参考范围",
    range8: "（冠状心血管疾病主要危险因素）",
    range9: "血糖参考范围",
    range10: "餐前空腹",
    range11: "餐后2小时",
    range12: "尿酸参考范围",
    range13: ["男性", "女性"],
    range14: [
      "临界值",
      "正常值",
      "正常（佳）",
      "正常（最佳）",
      "异常（低）",
      "异常（高）",
      "异常（超高）"
    ],

    pressure1: "测量数据仅供参考，请勿作为医疗诊断数据和用药指导。",
    pressure2: "血液在血管内流动时作用于单位面积血管壁的侧压力，它是推动血液在血管内流动的动力。在不同血管内被分别称为动脉血压、毛细血管压和静脉血压，通常所说的血压是指体循环的动脉血压。",
    pressure3: "正常人安静状态下每分钟心跳的次数，也叫安静心率，一般为60～100次/分，可因年龄、性别或其他生理因素产生个体差异。一般来说，年龄越小，心率越快，老年人心跳比年轻人慢，女性的心率比同龄男性快，这些都是正常的生理现象。安静状态下，成人正常心率为60～100次/分钟，理想心率应为55～70次/分钟（运动员的心率较普通成人偏慢，一般为50次/分钟左右）。",

    fat1: "血浆中的中性脂肪（甘油三酯）和类脂（磷脂、糖脂、固醇、类固醇）的总称，广泛存在于人体中。它们是生命细胞的基础代谢必需物质。 所有的血脂都和蛋白质结合成脂蛋白。而脂蛋白的基本结构是不同含量的甘油三酯为核心，周围包围一层磷脂、胆固醇和蛋白质分子。脂蛋白根据密度分为：乳糜微粒CM、极低密度脂蛋白VLDL、低密度脂蛋白LDL、高密度脂蛋白HDL。其中甘油三酯的主要携带者是乳糜微粒和极低密度脂蛋白，胆固醇的主要携带者是低密度脂蛋白和高密度脂蛋白。",
    fat2: "血脂",
    fat3: "血脂四项参考范围",

    sugar1: "葡萄糖是人体的重要组成成分，也是能量的重要来源。正常人体每天需要很多的糖来提供能量，为各种组织、脏器的正常运作提供动力。所以血糖必须保持一定的水平才能维持体内各器官和组织的需要。正常人血糖的产生和利用处于动态平衡的状态，维持在一个相对稳定的水平，这是由于血糖的来源和去路大致相同的结果。",
    sugar2: "血糖的来源包括：",
    sugar3: "①食物消化、吸收；",
    sugar4: "②肝内储存的糖元分解；",
    sugar5: "③脂肪和蛋白质的转化；",
    sugar6: "血糖的去路包括：",
    sugar7: "①氧化转变为能量；",
    sugar8: "②转化为糖原储存于肝脏、肾脏和肌肉中；",
    sugar9: "③转变为脂肪和蛋白质等其他营养成分加以储存。胰岛是体内调节血糖的血糖浓度的主要器官，肝脏储存肝糖元。此外，血糖浓度还受神经、分泌激素的调节；",

    ua1: "正常情况下，体内的尿酸大约有1200毫克，每天新生成约600毫克，同时排泄掉600毫克，处于平衡的状态。但如果体内产生过多来不及排泄或者尿酸排泄机制退化，则体内尿酸滞留过多，当血液尿酸浓度大于7毫克/分升，导致人体体液变酸，影响人体细胞的正常功能，长期置之不理将会引发痛风。另外，过于疲劳或是休息不足也可导致代谢相对迟缓进而导致痛风发病。",
    ua2: "血中尿酸全部从肾小球滤过，其中98%在近曲小管中段又被分泌到肾小球腔内，然后50%重吸收的尿酸在近曲小管中段又被分泌到肾小管腔内,在近曲小管直段又有40%～44%被重吸收，只有6%～10%尿酸排出。正常人体内尿酸的生成与排泄速度基本恒定。体液中尿酸含量变化可以充分反映出人体内代谢、免疫等机能的状况。",

    setUp1: "其他",
    setUp2: "使用方法",
    setUp3: "常见问题",

    method1: "一键开机",
    method2: "长按“0”键 开机，开机前请确认仪器电量充足。",
    method3: "参数设置",
    method4: "通过 “0”、“<”、“>”选择设置时间、单位、样本、记录查询、质控测试、语音等功能参数。",
    method5: "数据传输",
    method6: "仪器开机后自动连接服务器，检测结果自动上传。",
    method7: "数据共享",
    method8: "仪器连接服务器成功后提示用户绑定手机号码，数据可以共享到个人手机。",
    method9: "项目选择",
    method10: "仪器默认血压测试，可通过“血样”、“血压”切换血样模式和血压模式。",
    method11: "血样检测",
    method12: "血样检测模块需要按照检测项目在对应检测区域插卡检测，不可混测，检测前应做CODE码校正，血脂和血糖、尿酸取血方式不同，应严格按照项目要求操作，使用前应仔细血毒说明书，按照选择血样测试模式-CODE码校正仪器-微量采血&试纸卡插卡待机-试纸取血&仪器检测的步骤完成血样检测。",
    method13: "使用微信扫描二维码之后即开启《小程序》并绑定仪器。",
    method14: "血压检测",
    method15: "操作步骤为：",
    method16: "袖带连接血压计——",
    method17: "系好袖带——",
    method18: "选择血压检测模式——",
    method19: "仪器检测血压",

    faq1: "血脂光学分析模块异常",
    faq2: "清理血脂模块/清洁镜面/返厂维修",
    faq3: "血脂测试异常",
    faq4: "重新测试（测试过程中勿动测试卡）",
    faq5: "质控测试异常",
    faq6: "重新质控试/联系厂家",
    faq7: "血压测试异常",
    faq8: "查看袖带、仪器连接/质控测试/返厂维修",
    faq9: "血糖/尿酸CODE卡异常",
    faq10: "确认code卡/更换code卡",
    faq11: "血脂CODE卡异常",
    faq12: "正确插入code卡",
    faq13: "血糖/尿酸试纸异常",
    faq14: "确认试纸是否过期/插入正确项目",
    faq15: "血糖/尿酸测试异常",
    faq16: "确认试异常拔出/重新插入/重新测试",
    faq17: "测试结果高于/低于阈",
    faq18: "多次测试/医院检测",
    faq19: "温度计和电池图标：超高/低温、低电",
    faq20: "更换操作环境/仪器充电",
    faq21: "其他常见问题：",
    faq22: "1）一定要用酒精或清水清洁手指；手上的护肤产品一定要洗干净；",
    faq23: "2）清洁后一定要等到完全干才扎手指；",
    faq24: "3）第一滴血一定要擦掉；",
    faq25: "4）血从手指两边挤，并尽量一次多挤一些出来；",
    faq26: "5）血糖和尿酸要在出血30秒之内吸血；",
    faq27: "6）采血管是虹吸原理，不需要捏顶部，自动会吸够40ul，不会多不会少；——不能多也不能少，否则测量会不准确；",
    faq28: "7）要保证一体机和试纸是同一个温度，刚从冰箱拿出来的试纸（罐）要静置30分钟；",
    faq29: "8）手指不能触碰试纸虹吸区域；",
    faq30: "9）采血管不能触碰血脂卡第一层的清水膜；",
    faq31: "10）采血管中的血一定要一次性滴入血脂卡；",
    faq32: "11）腹泻、呕吐、运动等缺少状况下血样测试会不准确；",
    faq33: "12）试纸罐一定要及时盖上；",

    record1: ["日", "周", "月", "年"],
    record2: ["周日", "周一", "周二", "周三", "周四", "周五", "周六"],
    record3: "血压趋势",
    record4: "收缩压",
    record5: "舒张压",
    record6: "测量次数",
    record7: "正常次数",
    record8: "异常次数",
    record9: "血压记录",
    record10: "血脂趋势",
    record11: "血脂记录",
    record12: "血糖趋势",
    record13: "血糖记录",
    record14: "尿酸趋势",
    record15: "尿酸记录",
    record16: "暂无数据",
    record17: "餐前",
    record18: "餐后",
    record19: "血压异常记录",
    record20: "血脂异常记录",
    record21: "血糖异常记录",
    record22: "尿酸异常记录",
    record23: [
      "1月",
      "2月",
      "3月",
      "4月",
      "5月",
      "6月",
      "7月",
      "8月",
      "9月",
      "10月",
      "11月",
      "12月"
    ]
  },

  // 成员页
  member: {
    //首页
    index1: "我的群组",
    index2: "健康群组",
    index3: "点击查看健康数据",
    index4: "创建群组",
    index5: "我加入的群组",
    index6: "数据异常设置",
    index7: "暂无群组",
    index8: "暂未加入群组",
    index9: "待处理",
    index10: "通过二维码/微信/手机/邮箱等邀请加入",

    //创建群组
    addgroup1: "群组名称",
    addgroup2: "群组类型",
    addgroup3: "请填写群组名称",
    addgroup4: "家庭",
    addgroup5: "公司",
    addgroup6: "好友",
    addgroup7: "医院病房",
    addgroup8: "学校教室",
    addgroup9: "确定",
    addgroup10: "取消",
    addgroup11: "保存",
    addgroup12: "群组名已经存在",

    //成员列表
    memberlist1: "成员列表",
    memberlist2: "有",
    memberlist3: "项异常",
    memberlist4: "正常",
    memberlist5: "邀请新成员",
    memberlist6: "解散",
    memberlist7: "暂无成员",
    memberlist8: "加载中...",
    memberlist9: "是否解散此群？",
    memberlist10: "解散成功",
    memberlist11: "保存成功",
    memberlist12: "修改群组信息",
    memberlist13: "解散群组",
    memberlist14: "健康概览",
    memberlist15: "项正常",
    memberlist16: "项异常",
    memberlist17: "点击查看",
    memberlist18: "昨日无数据",
    memberlist19: "昨日",

    //修改成员
    updatemember1: "头像",
    updatemember2: "更换",
    updatemember3: "原昵称",
    updatemember4: "修改昵称",

    //健康数据
    healthdata1: "的健康数据",
    healthdata2: "健康数据",
    healthdata3: "日",
    healthdata4: "一",
    healthdata5: "二",
    healthdata6: "三",
    healthdata7: "四",
    healthdata8: "五",
    healthdata9: "六",
    healthdata10: "心率",
    healthdata11: "血压",
    healthdata12: "收缩压",
    healthdata13: "舒张压",
    healthdata14: "体温",
    healthdata15: "血氧饱和度",
    healthdata16: "睡眠",
    healthdata17: "血脂四项",
    healthdata18: "胆固醇",
    healthdata19: "甘油三酯",
    healthdata20: "低密度脂蛋白胆固醇",
    healthdata21: "高密度脂蛋白胆固醇",
    healthdata22: "血糖",
    healthdata23: "餐前",
    healthdata24: "餐后",
    healthdata25: "尿酸",
    healthdata26: "胎心",
    healthdata27: "步数",
    healthdata28: "步",
    healthdata29: "卡路里",
    healthdata30: "千卡",
    healthdata31: "距离",
    healthdata32: "千米",
    healthdata33: "配速",
    healthdata35: "秒/公里",
    healthdata36: "分",
    healthdata37: "正在加载健康数据",
    healthdata38: "运动记录",
    healthdata39: "异常",
    healthdata40: "未授权",
    healthdata41: "修改成员信息",
    healthdata42: "删除成员",
    healthdata43: "邮箱：",
    healthdata44: "手机：",
    healthdata45: "是否删除此成员？",

    //邀请成员
    addmember1: "邀请成员",
    addmember2: "让关心你健康的人更加关心你跨越距离，关爱更及时",
    addmember4: "无论多遥远，亲友之间可以实时查看健康状况",
    addmember5: "了解详情",
    addmember6: "健康群组成员",
    addmember7: "邀请",
    addmember8: "加入",
    addmember9: "扫码邀请",
    addmember10: "微信邀请",
    addmember11: "通过扫二维码邀请加入群组",
    addmember12: "通过微信邀请加入群组",
    addmember13: "手机号/邮箱邀请",
    addmember14: "通过手机号/邮箱邀请加入群组",

    // 群组二维码
    code1: "群组二维码",
    code2: "健康管理群",
    code3: "该二维码5分钟内有效，请及时使用",

    //群组邀请
    invide1: "群组邀请",
    invide2: "成员健康",
    invide3: "邀请你加入群组...",
    invide4: "加入该群组",
    invide5: "为了您的数据安全，建议在加入群组前核查群组信息",
    invide6: "加入群组后，您将授权关注者可以查看您的健康数据 ",

    //分享健康数据设置
    sethealthdata1: "健康数据设置",
    sethealthdata2: "确定",
    sethealthdata3: "请设置昵称",
    sethealthdata4: "全部允许",
    sethealthdata5: "设置昵称",
    sethealthdata6: "保存",
    sethealthdata7: "请输入",
    sethealthdata8: "请上传图片格式",
    sethealthdata9: "请设置昵称和头像",
    sethealthdata10: "请设置头像",
    sethealthdata11: "昵称长度为1-8个字符",
    // 设置数据区间
    setscope1: "心率上下限区间",
    setscope2: "体温上下限区间",
    setscope3: "睡眠上下限区间",
    setscope4: "胎心上下限区间",
    setscope5: "餐前血糖",
    setscope6: "餐后血糖",
    setscope7: "血氧上下限区间",
    setscope8: "男性尿酸",
    setscope9: "女性尿酸",
    setscope10: "收缩压",
    setscope11: "舒张压",
    setscope12: "上限",
    setscope13: "下限",
    setscope14: "健康数据异常设置",
    setscope15: "设置成功",
    setscope16: "上限",
    setscope17: "下限",

    //下载页
    onload1: "点击",
    onload2: "加入健康群组",
    onload3: "请用浏览器打开",
    onload4: "知道了",
    onload5: "友宏健康 智享健康每一天",
    onload6: "appstore免费下载",
    onload7: "免费下载",
    onload8: "链接已失效",
    onload9: "二维码已失效",
    onload10: "加入成功",

    // 待处理
    pending1: "同意",
    pending2: "拒绝",
    pending3: "重新发送邀请",
    pending4: "暂无数据",
    pending5: "邀请已发送，等待用户同意邀请",
    pending6: "确认",

    guide1: "进入成员健康后，需要先创建相应类型的群组。",
    guide2: "创建群组后，进入群组中，可以查看用户的健康概览，也可以邀请新成员进入群组。",
    guide3: "群组中邀请新成员，可通过扫码，微信，手机号/邮箱等方式邀请。新成员加入群组后，您可查看TA每天的健康动态。",
    guide4: "点击查看健康概览，可以查看成员的健康数据，并可判断正常与异常。",
    guide5: "下一步",
    guide6: "完成",

    invite1: "通过手机号/邮箱邀请",
    invite2: "请输入账号",
    invite3: "请输入手机号",
    invite4: "请输入邮箱",
    invite5: "请输入正确的手机号",
    invite6: "请输入正确的邮箱",
    invite7: "已加入该群组",
    invite8: "用户不存在",
    invite9: "请选择国家或地区",
    invite10: "请输入搜索关键词",
    invite11: "确认用户",
    invite12: "邀请TA",
  },
  
  // JCRing成员页
  JCRing_member: {
    //首页
    index1: "会員の健康状態",
    index2: "健康グループ",
    index3: "メンバー",
    index4: "グループを追加します",
    index5: "参加したグループ",
    index6: "アラート設定",
    index7: "愛する人の健康を気遣います",
    index8: "まだグループに参加していません",
    index9: "メッセージセンター",
    index10: "携帯電話/メール/QRコード/WeChatで参加に招待します",


    //创建群组
    addgroup1: "グループ名",
    addgroup2: "グループタイプ",
    addgroup3: "グループ名を記入してください",
    addgroup4: "家族グループ",
    addgroup5: "会社のグループ",
    addgroup6: "その他のグループ",
    addgroup7: "医療グループ",
    addgroup8: "学校グループ",
    addgroup9: "確認",
    addgroup10: "キャンセル",
    addgroup11: "すぐに作成",
    addgroup12: "グループ名重複",


    //成员列表
    memberlist1: "メンバーリスト",
    memberlist2: "あり",
    memberlist3: "異常",
    memberlist4: "正常",
    memberlist5: "メンバー追加",
    memberlist6: "解散",
    memberlist7: "メンバーはまだいません",
    memberlist8: "読み込み中...",
    memberlist9: "このグループを解散しますか？",
    memberlist10: "解散しました",
    memberlist11: "保存しました",
    memberlist12: "グループ情報の変更",
    memberlist13: "グループを解散します",
    memberlist14: "健康概要",
    memberlist15: "正常",
    memberlist16: "異常",
    memberlist17: "クリックして確認",
    memberlist18: "昨日データなし",
    memberlist19: "昨日",
    memberlist20: "送信済み",
    memberlist21: "グループ招待、確認中",


    //修改成员
    updatemember1: "プロフィール画像",
    updatemember2: "変更",
    updatemember3: "元のニックネーム",
    updatemember4: "ニックネームの編集",

    //健康数据
    healthdata1: "の健康データ",
    healthdata2: "健康データ",
    healthdata3: "日曜日",
    healthdata4: "月曜日",
    healthdata5: "火曜日",
    healthdata6: "水曜日",
    healthdata7: "木曜日",
    healthdata8: "金曜日",
    healthdata9: "土曜日",
    healthdata10: "心拍数",
    healthdata11: "心拍変動性",
    healthdata12: "収縮圧",
    healthdata13: "拡張圧",
    healthdata14: "体温",
    healthdata15: "酸素飽和度",
    healthdata16: "睡眠",
    healthdata17: "ストレス",
    healthdata18: "コレステロール",
    healthdata19: "トリグリセリド",
    healthdata20: "低密度リポプロテイン",
    healthdata21: "高密度リポプロテイン",
    healthdata22: "血糖",
    healthdata23: "食前",
    healthdata24: "食後",
    healthdata25: "最大酸素摂取量",
    healthdata26: "呼吸",
    healthdata27: "歩数",
    healthdata28: "步",
    healthdata29: "カロリー",
    healthdata30: "キロカロリー",
    healthdata31: "距離",
    healthdata32: "キロメートル",
    healthdata33: "ペース",
    healthdata35: "秒/キロメートル",
    healthdata36: "分",
    healthdata37: "健康データを読み込んでいます",
    healthdata38: "運動データ",
    healthdata39: "警報 です",
    healthdata40: "未承認",
    healthdata41: "メンバー情報の編集",
    healthdata42: "メンバー削除",
    healthdata43: "メールアドレス：",
    healthdata44: "携帯電話：",
    healthdata45: "このメンバーを削除しますか？",
    healthdata46: "未来の日付は表示できません。",
    healthdata47: "です",
   



    //邀请成员
    addmember1: "メンバーを招待します",
    addmember2: "メンバーアカウントを追加します",
    addmember4: 'メンバーアカウント"を通じて、メンバーの健康データを閲覧し、警告データの範囲を設定して、メンバーの健康をよりよく注意することができます。',
    addmember5: "詳細を確認します",
    addmember6: "健康グループのメンバー",
    addmember7: "招待",
    addmember8: "参加します",
    addmember9: "QRコードで招待します",
    addmember10: "WeChatで招待します",
    addmember11: "QRコードでグループに参加を招待します",
    addmember12: "WeChatを使用してグループに参加を招待します",
    addmember13: "電話番号/メールアドレスで招待します",
    addmember14: "電話番号/メールアドレスでグループに参加を招待します",
    addmember15:'メンバーを招待して、メンバーの健康状態を知ることができます',
    addmember16:'招待を送信します',
    addmember17:'送信済み',
    addmember18:'確認中',
    addmember19:'参加しました',
    addmember20:'今すぐシェアします',
    addmember21:'画像を保存します',
    addmember22:'辞退しました',
    addmember23:'ログアウトしました',
    addmember24:'相手がログアウトしました',
    addmember25:'相手が辞退しました',
    addmember26:"相手が参加しました'",
    addmember27: "その他の追加方法です", 



    // 群组二维码
    code1: "グループのQRコード",
    code2: "健康管理グループ",
    code3: "このQRコードの有効期限は5分です、時間内にご利用ください",


    //群组邀请
    invide1: "グループ招待",
    invide2: "会員健康",
    invide3: "グループに招待されています...",
    invide4: "グループに参加してください",
    invide5: "データのセキュリティのため、グループに参加する前にグループ情報を確認することをお勧めします",
    invide6: "グループに参加することで、フォロワーがあなたの健康データを閲覧することを許可します ",


    //分享健康数据设置
    sethealthdata1: "健康データの設定",
    sethealthdata2: "確定",
    sethealthdata3: "ニックネームを設定してください",
    sethealthdata4: "すべて許可します",
    sethealthdata5: "ニックネームの設定",
    sethealthdata6: "保存",
    sethealthdata7: "入力してください",
    sethealthdata8: "画像形式をアップロードしてください。",
    sethealthdata9: "ニックネームと個人写真をアップロードしてください",
    sethealthdata10: "個人写真をアップロードしてください",
    sethealthdata11: "ニックネームの長さ 1～8文字",

    // 设置数据区间
    setscope1: "心拍数の上限と下限の範囲",
    setscope2: "体温の上下幅",
    setscope3: "睡眠時間の上限と下限",
    setscope4: "胎児心拍数の上限と下限",
    setscope5: "食前グルコース",
    setscope6: "食後グルコース",
    setscope7: "オキシメトリーの上限と下限",
    setscope8: "男性尿酸",
    setscope9: "女性尿酸",
    setscope10: "収縮期血圧",
    setscope11: "最低血圧",
    setscope12: "上限",
    setscope13: "下限",
    setscope14: "早期警告の設定",
    setscope15: "セットアップ成功",
    setscope16: "上限",
    setscope17: "下限",
    setscope18: "警告",


    //下载页
    onload1: "クリック",
    onload2: "健康グループに参加します",
    onload3: "ブラウザで開いてください",
    onload4: "了解",
    onload5: "毎日を健康に",
    onload6: "アップストア 無料ダウンロード",
    onload7: "無料ダウンロード",
    onload8: "リンクが機能しなくなりました",
    onload9: "QRコードは無効です",
    onload10: "サクセスに参加します",


    // 待处理
    pending1: "同意",
    pending2: "拒否",
    pending3: "招待状の再送",
    pending4: "データなし",
    pending5: "招待が送信され、ユーザーが招待に同意するのを待ってください",
    pending6: "確認",
    pending7: "退出",

    guide1: "健康グループを作り、名前を付けてください。",
    guide2: "グループを作成したら、グループにアクセスしてユーザーの健康状態の概要を確認し、新しいメンバーをグループに招待します。",
    guide3: "コードスキャン、微信（WeChat）、携帯電話/メールによって、新しいメンバーをグループに招待することができます。 新メンバーがグループに参加した後、TAの毎日の健康ニュースを見ることができます。",
    guide4: "健康概要の表示」をクリックすると、会員の健康データが表示され、正常・異常が判定されます。",
    guide5: "次のステップ",
    guide6: "完成",
    guide7:"警告値超過",

    invite1: "携帯電話番号／Eメールによる招待",
    invite2: "アカウント番号を入力してください。",
    invite3: "携帯電話番号を入力してください。",
    invite4: "メールアドレスを入力してください",
    invite5: "携帯電話番号を入力してください。",
    invite6: "メールアドレスを入力してください。",
    invite7: "グループに参加しました",
    invite8: "ユーザーが存在していません",
    invite9: "国または地域を選択してください",
    invite10: "検索キーワードを入力してください",
    invite11: "ユーザーの確認",
    invite12: "TAを招待します",

  }
};



// WEBPACK FOOTER //
// ./src/lang/ja.js